import { FC } from 'react';
import GentianTokenSVG from '../../Assets/Gentian_Token.svg';

interface GentianTokenProps {
  height?: string;
  width?: string;
}

export const GentianToken: FC<GentianTokenProps> = ({ height = '24px', width = '24px' }) => {
  return <img src={GentianTokenSVG} alt="Gentian Token" style={{ marginRight: '10px', height, width }} />;
};
